import React from "react";
import { Link, useHistory } from "react-router-dom";

import { isNative } from "~/lib/utils";

import styles from "../css/Auth.module.css";

export function SignupHint({ customText }: { customText?: string }) {
	const { subdomain } = window.INITIAL_STATE;
	const rootDomain = window.ROOT_DOMAIN ?? ".fellow.app";
	const {
		location: { search },
	} = useHistory();

	if (subdomain) {
		return (
			<h5>
				Looking for a different workspace? <a href={`https://${rootDomain.slice(1)}/auth/login/`}>Log in here</a>
			</h5>
		);
	}

	if (isNative) return null;

	const location = {
		pathname: "/auth/signup/",
		search,
	};

	return (
		<h5 className={styles.signupHint}>
			{customText ?? "Don’t have a Fellow account?"} <Link to={location}>Sign up</Link>
		</h5>
	);
}

export function LoginHint() {
	const {
		location: { search },
	} = useHistory();

	const location = {
		pathname: "/auth/login/",
		search,
	};

	return (
		<h5 style={{ marginTop: 0 }}>
			Already have a Fellow account? <Link to={location}>Log in</Link>
		</h5>
	);
}

interface GuestInviteHintProps {
	guestUrl: string;
	inviteAccount: string;
}

export function GuestInviteHint({ guestUrl, inviteAccount }: GuestInviteHintProps) {
	return (
		<h5 style={{ marginTop: 0 }}>
			<a href={guestUrl}>Join {inviteAccount} as a guest</a> (limited collaboration)
		</h5>
	);
}

export function Terms() {
	return (
		<h5>
			<div>
				By continuing I agree to the{" "}
				<a href="https://www.fellow.app/privacy-policy/" target="_blank" rel="noopener">
					Privacy Policy
				</a>{" "}
				and{" "}
				<a href="https://www.fellow.app/terms-of-use/" target="_blank" rel="noopener">
					{" "}
					Terms of Use{" "}
				</a>
			</div>
			<div className={styles.captchaTerms}>
				This site is protected by{" "}
				<a href="https://www.google.com/recaptcha/about/" target="_blank" rel="noopener noreferrer">
					reCAPTCHA
				</a>
				.
			</div>
		</h5>
	);
}
